module.exports = __webpack_public_path__ + "static/media/notice.8cbc7bd5.png";